export const REMOVE_USER_TEXT = 'Remove user'
export const CANCEL_PENDING_INVITE_TEXT = 'Cancel Invitation'
export const SEND_REMINDER_TEXT = 'Send an email notification'
export const CHANGE_TO_TEXT = 'Change to'
export const REINVITE_AS_TEXT = 'Invite as'
